<template>
    <radial-progress-bar
        :diameter="diameter"
        :completed-steps="completedSteps"
        :total-steps="totalSteps"
        :stroke-width="strokeWidth"
        :inner-stroke-width="innerStrokeWidth"
        inner-stroke-color="#CAD0D8"
        start-color="#FF671D"
        stop-color="#FF671D"
        :animate-speed="3000"
    >
        <slot />
    </radial-progress-bar>
</template>

<script>
    import RadialProgressBar from "vue-radial-progress"
    export default {
        name: "RadialProgress",
        components: {
            RadialProgressBar
        },
        props: {
            diameter: Number,
            completedSteps: {
                type: Number,
                required: true
            },
            totalSteps: {
                type: Number,
                required: true
            },
            strokeWidth: Number,
            innerStrokeWidth: Number
        }
    }
</script>